import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import MegaMenu from "./megamenu";
import { Link, WithHostUrl } from "@quintype/components";
import HeaderBrandRow from "./header-brand-row";
import styles from "./gamestyles.m.css";
import assetify from "@quintype/framework/assetify";
import logo from "../../../../assets/images/vikatan-logo.png";

import { checkAppSlug } from "../../utils/utils";

class GlanceHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMegaMenuOpen: false,
      isSearchOpen: false,
      loginData: {}
    };
  }

  render() {
    if (checkAppSlug()) {
      return false;
    }

    return (
      <React.Fragment>
        <div className={`${styles["glance-header"]}`}>
          <WithHostUrl>
            {({ primaryHostUrl }) => (
              <Link
                className={styles["home-link"]}
                aria-label="Vikatan"
                href={primaryHostUrl ? primaryHostUrl + "/" : "/"}
              >
                <img alt="Vikatan" src={assetify(logo)} className={styles["brand-logo"]} width="240px" height="50px" />
              </Link>
            )}
          </WithHostUrl>
        </div>
      </React.Fragment>
    );
  }
}

GlanceHeader.propTypes = {
  menuGroup: MegaMenu.propTypes.menuGroup,
  appStoreLinks: MegaMenu.propTypes.appStoreLinks,
  socialLinks: MegaMenu.propTypes.socialLinks,
  latestIssues: MegaMenu.propTypes.latestIssues,
  subscriptionLink: HeaderBrandRow.propTypes.subscriptionLink,
  pageLoading: PropTypes.bool,
  addUser: PropTypes.func,
  vikatanHosts: HeaderBrandRow.propTypes.vikatanHosts
};

function mapStateToProps(state) {
  const data = get(state, ["qt", "data", "header"]);
  const pageLoading = get(state, ["pageLoading"], false);
  const vikatanHosts = get(state, ["qt", "config", "vikatanHosts"]);
  return data ? { ...data, pageLoading, vikatanHosts } : {};
}

export default connect(mapStateToProps)(GlanceHeader);
